import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { AuthProvider } from "@/lib/auth";
import { SiteSettingsProvider } from "@/lib/settings";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Storia from "@/pages/Storia";
import Lavori from "@/pages/Lavori";
import Novita from "@/pages/Novita";
import NovitaDettaglio from "@/pages/NovitaDettaglio";
import Admin from "@/pages/Admin";
import { Toaster } from "@/components/ui/sonner";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const doScroll = () => {
        const el = document.querySelector(hash);
        if (!el) return;
        if (window.__lenis) window.__lenis.scrollTo(el, { offset: -40, duration: 1.2 });
        else el.scrollIntoView({ behavior: "smooth" });
      };
      const t1 = setTimeout(doScroll, 350);
      const t2 = setTimeout(doScroll, 1600);
      return () => {
        clearTimeout(t1);
        clearTimeout(t2);
      };
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    document.title = "Lattanzi Costruzioni | Impresa Edile a Fermo dal 1969";
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-charcoal text-foreground">
      <AuthProvider>
        <SiteSettingsProvider>
          <BrowserRouter>
          <ScrollToTop />
          <Nav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/storia" element={<Storia />} />
            <Route path="/lavori" element={<Lavori />} />
            <Route path="/lavori/novita/:id" element={<NovitaDettaglio />} />
            <Route path="/novita" element={<Novita />} />
            <Route path="/area-riservata" element={<Admin />} />
          </Routes>
          <Footer />
          </BrowserRouter>
        </SiteSettingsProvider>
        <Toaster theme="dark" position="top-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
